import { withStyles } from '@material-ui/core';

import { styles } from './CallBox.styles';
import CallBox from './CallBox';

const CallBoxContainer = withStyles(styles)(CallBox);

export default CallBoxContainer;
